import instance from './request'
import Vue from 'vue'

export function getOnceToken(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/swap/once/token',
    data,
    method: 'post'
  })
}

export function getHomeInfo() {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobile/api/index.data',
    method: 'get'
  })
}
export function getHomePortalshow() {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobileManage/getportalshowforuser.do',
    method: 'get'
  })
}
export function getOnlineList() {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobile/api/online.data',
    method: 'get'
  })
}
/* 活动 */
export function getEventList(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobile/api/event.data',
    params,
    method: 'get'
  })
}
export function getLabelTypeList(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/eventLabelClassification/selectLabelTypeList.do',
    params,
    method: 'get'
  })
}
export function getLabelsByType(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/eventLabelInfo/selectRecLabelFortType.do',
    params,
    method: 'get'
  })
}
/* 新闻详情 */
export function getNewsDetail(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/news/selectNewsInfoById.do',
    params,
    method: 'get'
  })
}
/* 通知新闻列表 */
export function getNoticeList(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobile/api/selectnews.do',
    params,
    method: 'get'
  })
}
/* 发现 */
export function getFindInfo(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobile/api/find.data',
    method: 'post',
    data
  })
}

export function getUser() {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/unifiedPortal/selectUserInfoById.do',
    method: 'get'
  })
}
export function saveFeedback(value) {
  return instance({
    url: `/event/mobile/api/insertcomplain.do?content=${value}`,
    method: 'post'
  })
}

export function getHistory() {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobile/api/history.data',
    method: 'get'
  })
}

export function getLessonByCode(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobile/api/geteventbycode.do',
    params,
    method: 'get'
  })
}
export function getLessonHomeworks(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobile/api/eventhomeworks.data',
    params,
    method: 'get'
  })
}
export function saveHomeWork(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobile/api/savehomework.data',
    data,
    method: 'post'
  })
}
export function upload(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/upload/upload_file.do',
    data,
    method: 'post'
  })
}

/* 直播 */
export function getPlayDeatil(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/mobile/api/detail.data',
    params,
    method: 'get'
  })
}
export function getActiveComments(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/event/comments/get',
    params,
    method: 'get'
  })
}
export function insertMsg(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/eventmessage/insertEventMessage.do',
    data,
    method: 'post'
  })
}

export function activityDoUserSetting(id) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/indexPage/doUserSetting/${id}`
  })
}

export function getInsertMsg(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/indexPage/selectEventMassage',
    params,
    method: 'get'
  })
}

export function getLiveUrl(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/indexPage/getLiveUrls',
    params,
    method: 'get'
  })
}

export function getAllEventBarrageInfo(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/indexPage/getAllEventBarrageInfo',
    method: 'get',
    params
  })
}
export function saveBarrageInfo(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/indexPage/saveEventBarrageInfo',
    method: 'post',
    data
  })
}
export function getCommonentOpen(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/event/comments/get',
    params
  })
}
export function doUseGood(id) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/mobile/api/doUserGood/${id}`,
    method: 'get'
  })
}
export function doUseGrade(id) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/mobile/api/doUserGrade/${id}`,
    method: 'get'
  })
}

export function saveAction(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/indexPage/saveEventAction',
    data,
    method: 'post'
  })
}

export function getResourcePlay(id) {
  return instance({
    url: `/event/resourceDetailPage/selectDataInfo/${id}`,
    method: 'get'
  })
}
export function selectComment(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/resourceDetailPage/selectComment',
    method: 'get',
    params
  })
}
export function sourceSaveAction(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/resourceDetailPage/saveAction',
    method: 'post',
    data
  })
}
export function addComment(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/resourceDetailPage/addComment',
    method: 'post',
    data
  })
}
// export function vertifyAuthInResource(id, pwd) {
//   return instance({
//     url: `/event/resourceDetailPage/verifyAuthPassword/${id}/${pwd}`,
//     method: 'post'
//   })
// }
// /resourceDetailPage/verifyPassword
export function vertifyAuthInResource(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/resourceDetailPage/verifyPassword',
    data,
    method: 'post'
  })
}

export function fallowUser(id, type) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/pcenterPage/fallowUser/${id}/${type}`,
    method: 'get'
  })
}

export function getEventBarrageInfoByTimeSlot(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/indexPage/getEventBarrageInfoByTimeSlot',
    params,
    method: 'get',
    hideloading: true
  })
}
export function getEventAuth(id) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/indexPage/verifyLookAuth/${id}`,
    method: 'get',
    hideloading: true
  })
}
export function vertifyAuth(id, pwd) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/indexPage/verifyLookAuthPassword/${id}/${pwd}`,
    method: 'post'
  })
}

/* 获取当前 IP 定位信息 */
export function getUserIpLocation(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/user/ip/location',
    params,
    method: 'get'
  })
}

/* 评课 */
export function getCourseList(id) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/eventcommentlesson/selectByParamsForAuth?eventId=${id}&isOpen=1`,
    method: 'get'
  })
}
export function formGetOneData(id) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/formGetOneData?formId=${id}`,
    method: 'get'
  })
}

export function formsaveAnswer(id, data) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/saveAnswer?templateUsedId=${id}`,
    data,
    method: 'post'
  })
}

export function selectStatic(formInfoId, eventId) {
  return instance({
    url:
      Vue.prototype.$ysUrl + `/event/indexPage/getAssessmentStatistics?templateUsedId=${formInfoId}&eventId=${eventId}`,
    method: 'get'
  })
}

export function selectAnswerByText(formInfoId, eventId) {
  return instance({
    url:
      Vue.prototype.$ysUrl +
      `/event/indexPage/selectAnswerByText?eventId=${eventId}&formInfoId=${formInfoId}&pageNo=1&pageSize=1000`,
    method: 'get'
  })
}
/* 签到 */
export function getattendance(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/verification/validation/getattendance.do',
    params,
    method: 'get',
    hideloading: true
  })
}
export function getSignSet(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/verification/attendance/sign/getset.do',
    params,
    method: 'get',
    hideloading: true
  })
}
export function signCheck(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/verification/attendance/sign/check.do',
    data,
    method: 'post',
    hideloading: true
  })
}
/* 验证 */
export function getValidation(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/verification/validation/get.do',
    params,
    method: 'get',
    hideloading: true
  })
}

export function validation(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/verification/validation/play.do',
    data,
    method: 'post',
    hideloading: true
  })
}
/* 答题 */

export function getExamAuth(id) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/indexPage/doUserEventManager/${id}`,
    method: 'get'
  })
}
export function getPaper(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/getpaper',
    params,
    method: 'get'
  })
}
export function getAllExam(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/all',
    params,
    method: 'get'
  })
}
export function examAddOrEdit(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/base/edit.do',
    data,
    method: 'post'
  })
}
export function releasebase(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/releasebase',
    params,
    method: 'get'
  })
}
export function examDelete(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/delete',
    params,
    method: 'get'
  })
}
export function getbase(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/getbase',
    params,
    method: 'get'
  })
}
export function getbasetotal(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/getbasetotal',
    params,
    method: 'get'
  })
}
export function getoptions(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/getoptions',
    params,
    method: 'get'
  })
}
export function getchoose(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/getchoose',
    params,
    method: 'get'
  })
}
export function getanswer(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/getanswer',
    params,
    method: 'get'
  })
}
export function getsimpletotal(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/getsimpletotal',
    params,
    method: 'get'
  })
}
export function baseSubmit(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/base/submit.do',
    data,
    method: 'post'
  })
}
export function getsimple(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/getsimple',
    params,
    method: 'get'
  })
}
export function simpleSubmit(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/simple/submit.do',
    data,
    method: 'post'
  })
}
export function simpleSend(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/simple/send.do',
    data,
    method: 'post'
  })
}
export function simpleStop(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/exam/stop',
    params,
    method: 'get'
  })
}
// export function releasebase(params) {
//   return instance({
//     url:   Vue.prototype.$ysUrl + '/event/exam/releasebase',
//     params,
//     method: 'get'
//   })
// }
/* oss上传 */
export function fileGetSign(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/oss/upload/getSign',
    params,
    method: 'get'
  })
}
export function fileCenterCallback(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/oss/upload/file-center-callback',
    data,
    method: 'post'
  })
}
export function attrCallback(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/oss/upload/attr-callback',
    data,
    method: 'post'
  })
}
export function ossUpload(url, data) {
  return instance({
    url,
    data,
    method: 'post'
  })
}

export function saveLookAction(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/classHour/saveLookAction',
    params,
    method: 'get'
  })
}
export function saveEventAction(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/indexPage/saveEventAction',
    data,
    method: 'post'
  })
}

export function getHomeAlumns(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/specialsPage/selectDataInfoPhone/0?pageNo=1&pageSize=4&specialsName=',
    params,
    method: 'get'
  })
}
export function getAlumnList(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/specialsPage/selectDataInfo/0',
    params,
    method: 'get'
  })
}
export function getAlumnById(id) {
  return instance({
    url: Vue.prototype.$ysUrl + `/event/specialsDetailPage/selectSpecialDetailInfoWithType/${id}`
  })
}
export function getAlumnDataById(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/specialsDetailPage/selectResourceDataInfo',
    params
  })
}

/* ============二部API================== */
// login
export function getTokenByonce(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/swap/token/byonce',
    params,
    method: 'get'
  })
}
export function login(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/loginByUserPwdNoOrg',
    data,
    method: 'post'
  })
}
export function getCode(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/smsSender/signup',
    data,
    method: 'post'
  })
}

export function checkPhone(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/signup/checkPhone',
    params,
    method: 'get'
  })
}

export function verifyCode(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/smsVerifyCode/signup',
    data,
    method: 'post'
  })
}
export function smsVerifyCode(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/account/smsVerifyCode',
    data,
    method: 'post'
  })
}

export function getCodeImg(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/checkCode/image',
    params,
    method: 'get'
  })
}

export function getAllorg(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/organizationUnit/all',
    params,
    method: 'get'
  })
}

export function smsSendModifyPwd(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/account/smsSendModifyPwd',
    params,
    method: 'get'
  })
}

export function setNewPwd(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/account/change/password/notLogin',
    data,
    method: 'post'
  })
}

export function setDefaultPwd(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/account/must/change/default/password',
    data,
    method: 'post'
  })
}

export function signup(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/smsSender/signup',
    data,
    method: 'post'
  })
}
export function authSignup(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/signUp',
    data,
    method: 'post'
  })
}
export function verifyPhone(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/signup/verify/phone',
    params,
    method: 'get'
  })
}

export function applyToOrg(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/auth/applyToOrg',
    data,
    method: 'post'
  })
}
/* 租户 */
export function tanlent(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/tenant/query',
    params,
    method: 'get',
    hideToken: true
  })
}

export function isOpenTenant() {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/system/isOpenTenant',
    method: 'get',
    hideToken: true
  })
}

export function getStage() {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/dict/getByType?type=stage',
    method: 'get'
  })
}
export function getGrade() {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/dict/getByType?type=grade',
    method: 'get'
  })
}
export function getSubject(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/external/getSelectSubjectByPeriodId',
    params,
    method: 'get'
  })
}
export function getVersion(params) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/subjectMgr/textbookVersions/getKeyAndValue',
    params,
    method: 'get'
  })
}
export function getTree(data) {
  return instance({
    url: Vue.prototype.$baseUrl + '/base-api/base/api/external/getTree',
    data,
    method: 'post'
  })
}

// tv-sign

export function tvAttendance(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/verification/verification/tv/sign/attendance.do',
    data,
    method: 'post'
  })
}

export function tvBindOrg(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/management/api/tv/binding.do',
    params,
    method: 'get'
  })
}
export function tvGetorgs(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/management/api/tv/getorgs.do',
    params,
    method: 'get'
  })
}
export function selectOrgByNameQuery(params) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/inside/selectOrgByNameQuery',
    params,
    method: 'get'
  })
}
export function getactiveAll(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/eventSign/mobile/all',
    data,
    method: 'post'
  })
}
export function getjoinactive(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/eventSign/mobile/join',
    data,
    method: 'post'
  })
}
export function geteventSignInfo(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/eventSign/index/getInfo',
    data,
    method: 'post'
  })
}
export function checksigns(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/eventSign/mobile/sign/check',
    data,
    method: 'post'
  })
}
export function signactive(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/eventSign/mobile/sign',
    data,
    method: 'post'
  })
}
export function signdetail(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/eventSign/mobile/sign/detail',
    data,
    method: 'post'
  })
}
export function certificateslist(data) {
  return instance({
    url: Vue.prototype.$ysUrl + '/event/eventSign/mobile/certificates/list',
    data,
    method: 'post'
  })
}
